export default __webpack_public_path__ + "static/media/slide-item4.e5e33849.svg";